import { type Language, useLanguage } from "@digipost/translate";

export function parseLanguage(languageValue: string | undefined): Language {
  switch (languageValue) {
    case "nn":
    case "en":
      return languageValue;
    default:
      return "nb";
  }
}

export function rootPath(language: string | undefined): string {
  return `/${parseLanguage(language)}`;
}

export function useRootPath(): string {
  const { language } = useLanguage();

  return rootPath(language);
}
